
export default function CtaSection() {
  return (
    <section className="py-20 px-6 bg-stone-50">
      <div className="max-w-4xl mx-auto">
        <div className="topo-cta-bg text-white rounded-lg overflow-hidden shadow-md">
          <div className="relative z-10 p-10 md:p-14 text-center">
            <div className="w-14 h-14 flex items-center justify-center mx-auto mb-6 bg-white/10 rounded-full">
              <i className="ri-chat-3-line text-3xl text-emerald-300"></i>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4 tracking-wide">
              Still Have Questions?
            </h2>
            <p className="text-lg text-gray-300 max-w-xl mx-auto leading-relaxed font-light mb-8">
              We&apos;re happy to talk through your specific situation. No pressure, no sales pitch — just straight answers about what we can do for your operation.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="/#contact"
                className="inline-flex items-center gap-2 bg-emerald-700 hover:bg-emerald-600 text-white font-bold px-8 py-4 rounded-md transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-send-line"></i>
                Contact Us
              </a>
              <a
                href="/roi-calculator"
                className="inline-flex items-center gap-2 border-2 border-white/30 hover:bg-white/10 text-white font-bold px-8 py-4 rounded-md transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-calculator-line"></i>
                Calculate Your Savings
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
